function NakiSearchForm(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var QUERY_MIN_LENGTH = 3;

	
	/* PRIVATE VARIABLES */
	var form;
	var inputFormState;
	var buttonBasic;
	var buttonAdvanced;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function initFormHandler(){
		var messageNumericValue = 'Zadejte prosím platnou hodnotu.';
		
		form.validate({
			rules: {
				query: {
					required: true,
					minlength: 3
				}
			},
			messages: {
				query: {
					required: "Zadejte prosím hledaný výraz.",
					minlength: jQuery.validator.format("Hledaný výraz musí mít alespoň {0} znaky.")
				},
				year_start: {
					number: messageNumericValue,
					min: messageNumericValue,
					max: messageNumericValue
				},
				year_end: {
					number: messageNumericValue,
					min: messageNumericValue,
					max: messageNumericValue
				},
				volume: {
					number: messageNumericValue,
					min: messageNumericValue,
					max: messageNumericValue
				},
				issue: {
					number: messageNumericValue,
					min: messageNumericValue,
					max: messageNumericValue
				}
			}
		});
	}
	
	
	function setFormState(state, resetFields){
		switch(state){
			case 'advanced':
				$('.search-form-basic', _this.container).hide();
				$('.search-form-advanced', _this.container).show();
				break;
				
			default:
				$('.search-form-basic', _this.container).show();
				$('.search-form-advanced', _this.container).hide();
				break;
		}
		
		if(resetFields){
			setDefaultFieldValues();
		}
		
		// store form state
		inputFormState.val(state);
	}
	
	
	
	/**
	 * Set form default values if it has not been submitted
	 */
	function setDefaultFieldValues(){
		$('input[name="year_start"]', form).val('');
		$('input[name="year_end"]', form).val('');
		$('input[name="volume"]', form).val('');
		$('input[name="issue"]', form).val('');
		$('input[name="search_article_title"]', form).prop('checked', true);
		$('input[name="search_article_annotation"]', form).prop('checked', true);
		$('input[name="search_article_content"]', form).prop('checked', true);
		$('input[name="search_author"]', form).prop('checked', true);
		$('input[name="search_keywords"]', form).prop('checked', true);
	}
	

	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			form = $('form', _this.container);
			inputFormState = $('input[name="form_state"]', _this.container);
			buttonBasic = $('.search-form-toggle.basic', _this.container);
			buttonAdvanced = $('.search-form-toggle.advanced', _this.container);
			
			// handlers		
			buttonBasic.click(function(e){
				e.preventDefault();
				setFormState('basic', true);
				
			});
			buttonAdvanced.click(function(e){
				e.preventDefault();
				setFormState('advanced', true);
			});
			
			// init
			initFormHandler();
			// set initial values if not submitted
			var formSubmitStatus = parseInt(NavigationUtils.getUrlParameterByName('naki_search'));
			if(formSubmitStatus !== 1) {
				setDefaultFieldValues();
			}
			// load form state after last submission
			setFormState(inputFormState.val());
			
			_this.inited = true;
		}
	};
	
	
	this.resetForm = function(){
		form[0].reset();
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
